import type { AxiosInstance, AxiosResponse } from 'axios';
import { HEADER } from './config';
import {
  isDevelopmentLabelResponse,
  withoutDevelopmentLabels,
} from './developmentLabels';
import type { RequestParams } from './types';

/** crm-client returnRequest 와 같은 호출 형태: request<T>({ method, url, queryParams, requestBody }) */
export const returnRequest =
  (client: AxiosInstance) =>
  <T>({
    method,
    url,
    headers,
    queryParams,
    requestBody,
    responseType,
    timeout,
    signal,
    credentialFlow,
    localSession,
    skipAuthRetry,
    idempotencyKey,
  }: RequestParams): Promise<AxiosResponse<T>> =>
    client
      .request<T>({
        method,
        url,
        params: queryParams,
        data: requestBody,
        headers: idempotencyKey
          ? { ...headers, [HEADER.IDEMPOTENCY_KEY]: idempotencyKey }
          : headers,
        responseType,
        timeout,
        signal,
        credentialFlow,
        localSession,
        skipAuthRetry,
      })
      .then((response) => {
        if (
          isDevelopmentLabelResponse(response.config.baseURL) &&
          (!responseType || responseType === 'json')
        ) {
          return { ...response, data: withoutDevelopmentLabels(response.data) };
        }
        return response;
      });
